import { AuthorData } from 'model/modules/chat/chatMessage';
import { ChatMessageAuthorType } from 'enums/modules/chat/chatMessageAuthorType';
import mapFileFromApi from 'rtkQuery/sharespro/mapper/shared/mapFileFromApi';

const mapAuthorDataFromApi = (resp: ApiAuthorData): AuthorData => {
  return {
    authorId: resp.author_id ?? null,
    fullname: resp.fullname ?? null,
    isMe: resp.is_me ?? null,
    photo: resp.photo !== null ? mapFileFromApi(resp.photo) : null,
    type: resp.type as ChatMessageAuthorType,
  };
};

export default mapAuthorDataFromApi;
